import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import {
  CAvatar,
  CDropdown,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react'
import {
  cilAccountLogout,
  cilSettings,
  cilUser,
  cilHome,
} from '@coreui/icons'
import CIcon from '@coreui/icons-react'

import avatar from '../../assets/images/avatars/blank_user_image.png'
import { Profile } from '../../API/player';

const AppHeaderDropdown = () => {

  const [profile, setProfile] = useState(null);
  const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE;

  useEffect(() => {
    let callAPI = async () => {
      let res = await Profile();
      if (res.status) {
        console.log(res.data.profile_image);
        setProfile(res.data);
      }
    }
    callAPI();
  }, [])

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle placement="bottom-end" className="py-0 pe-0" caret={false}>
        <div className='profile_header_userdash' style={{
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          // backgroundImage: profile && profile.profile_image ?
          //   `url(${IMAGE_URL}user/${profile.profile_image})` :
          //   `url(${IMAGE_URL}/blank_user.png)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>
          <img
            src={profile && profile.profile_image ? `${IMAGE_URL}user/${profile.profile_image}` : `${IMAGE_URL}/blank_user.png`}
            alt="Profile" style={{ height: "100%", width: "100%", borderRadius: "50%", objectFit: "cover" }}
          />
        </div>
        {/* <CAvatar src={avatar} size="md" /> */}
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        {/* <CDropdownHeader className="bg-body-secondary fw-semibold mb-2">Account</CDropdownHeader> */}
        {/* <CDropdownHeader className="bg-body-secondary fw-semibold my-2">Settings</CDropdownHeader> */}
        <Link to='/' className='text-decoration-none'>
          <CDropdownItem >
            <CIcon icon={cilHome} className="me-2" />
            <span> Home </span>
          </CDropdownItem>
        </Link>
        <Link to={'/admin/profile'} className='text-decoration-none'>
          <CDropdownItem>
            <CIcon icon={cilUser} className="me-2" />
            <span>My Profile</span>
          </CDropdownItem>
        </Link>
        <Link to={'/logout'} className='text-decoration-none' >
          <CDropdownItem>
            <CIcon icon={cilAccountLogout} className="me-2" />
            Log Out
          </CDropdownItem>
        </Link>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
